import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/solid";
import { ToastRecord, ToastType } from "../../containers/ToastContextWrapper";
import { cn } from "../utls/utils";

interface ToastProps {
  toast: ToastRecord;
  onClose: () => void;
}

function Toast({ toast, onClose }: ToastProps) {
  const base = "flex items-start gap-3 rounded-lg px-4 py-3 shadow-lg text-white";
  const typeStyles = {
    success: "bg-emerald-500",
    error: "bg-red-500",
    info: "bg-brown-500",
    warning: "bg-yellow-500",
  } as const;

  const variant: ToastType = toast.type ?? "info";

  const Icon =
    variant === "success"
      ? CheckCircleIcon
      : variant === "error"
      ? ExclamationCircleIcon
      : InformationCircleIcon;

  return (
    <div className={cn(base, typeStyles[variant])} role="alert">
      <Icon className="h-5 w-5 flex-shrink-0" />
      <div className="flex-1 text-sm">
        <p className="font-medium">{toast.title}</p>
        {toast.description && (
          <p className="text-sm/relaxed opacity-90">{toast.description}</p>
        )}
      </div>
      <button onClick={onClose} className="ml-2" aria-label="Close">
        <XMarkIcon className="w-4 h-4" />
      </button>
    </div>
  );
}

export default Toast;
